"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2049],{

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 99931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* reexport safe */ _A__WEBPACK_IMPORTED_MODULE_0__.A; }
/* harmony export */ });
/* harmony import */ var _A__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68);


/***/ }),

/***/ 20865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BasicBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34397);
/* harmony import */ var _BasicBlockStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60223);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);





var BasicBlockComponent = function BasicBlockComponent(props) {
  var styles = props.styles,
      children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "block" : _props$styleKey;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_BasicBlockStyle__WEBPACK_IMPORTED_MODULE_2__/* .BasicBlockStyle */ .V[styleKey], styles),
    children: children
  });
};

var BasicBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(BasicBlockComponent);

/***/ }),

/***/ 60223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ BasicBlockStyle; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79105);





var BasicBlockStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ").concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block),
    maxWidth: main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__/* .maxWidth.page1col */ .k.page1col,
    margin: "0 auto",
    boxSizing: "border-box"
  },
  blockWide: {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ").concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block),
    maxWidth: main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__/* .maxWidth.page1colWide */ .k.page1colWide,
    margin: "0 auto",
    boxSizing: "border-box"
  },
  blockFullWidth: {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " 0"),
    maxWidth: "100%",
    boxSizing: "border-box"
  },
  blockMultiCol: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("desktop"), {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ").concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block),
    margin: "0 auto",
    maxWidth: main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__/* .maxWidth.page2col */ .k.page2col,
    boxSizing: "border-box"
  })
});

/***/ }),

/***/ 98034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* reexport safe */ _BasicBlock__WEBPACK_IMPORTED_MODULE_1__.M; }
/* harmony export */ });
/* harmony import */ var _BasicBlockStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60223);
/* harmony import */ var _BasicBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20865);



/***/ }),

/***/ 12160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BasicBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79105);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80910);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);








var BasicBlockComponent = function BasicBlockComponent(props) {
  var children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "block" : _props$styleKey,
      _props$backgroundStyl = props.backgroundStyleKey,
      backgroundStyleKey = _props$backgroundStyl === void 0 ? "primary" : _props$backgroundStyl;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    css: [blockStyle[styleKey], backgroundStyle[backgroundStyleKey],  true ? "" : 0,  true ? "" : 0],
    children: children
  });
};

var BasicBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(BasicBlockComponent);
var blockStyle = {
  block: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page1col */ .k.page1col, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockWide: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page1colWide */ .k.page1colWide, ";margin:0 auto;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockFullWidth: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " 0;max-width:100%;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0),
  blockMultiCol: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";margin:0 auto;max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page2col */ .k.page2col, ";box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0),
  blockMultiColWide: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)((0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, ";margin:0 auto;max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth.page2colWide */ .k.page2colWide, ";box-sizing:border-box;}" + ( true ? "" : 0),  true ? "" : 0)
};
var backgroundStyle = {
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)( true ? "" : 0,  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary2: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("background-color:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .shadeColor */ .HO)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_4__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, -2), ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 65562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HotelDatePickerBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70917);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87536);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(32912);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69590);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27114);
/* harmony import */ var main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82011);
/* harmony import */ var main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19484);
/* harmony import */ var main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31264);
/* harmony import */ var main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(10780);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16201);
/* harmony import */ var main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71797);
/* harmony import */ var main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16341);
/* harmony import */ var _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96749);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14416);
/* harmony import */ var _utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49224);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12327);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }























var HotelDatePickerBlockComponent = function HotelDatePickerBlockComponent(props) {
  var _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "default" : _props$labelColorStyl,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t; // TODO: 旧reducerをそのまま使用


  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useWatch */ .qo)({
    control: control,
    name: ["checkin_date", "checkout_date"]
  }),
      _useWatch2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_useWatch, 2),
      checkinDateValue = _useWatch2[0],
      checkoutDateValue = _useWatch2[1];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      pickerDateType = _useState2[0],
      setPickerDateType = _useState2[1];

  var inputCheckInRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var inputCheckOutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(); // public shouldComponentUpdate(nextProps: any, nextState: any): boolean {
  //   return !isEqual(props, nextProps) || !isEqual(state, nextState);
  // }

  var onClickCheckinDate = function onClickCheckinDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate);
  };

  var onClickCheckoutDate = function onClickCheckoutDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
  };

  var sendDateEvent = function sendDateEvent(checkinDateString, checkoutDateString) {
    if (checkinDateString && checkoutDateString) {
      (0,_utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__/* .event */ .B)(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__/* .GoogleTagManagerEventTypes.date */ .T.date, {
        start_date: checkinDateString,
        end_date: checkoutDateString
      });
    }
  };

  var onComplete = function onComplete(startDate, endDate) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
    hidePicker();
  };

  var onUpdate = function onUpdate(startDate, endDate, isEndStep) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    if (!isEndStep) {
      setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
    setPickerDateType(null);
  }; // 再レンダリングの負荷が高い場合はメモ化検討する


  var fromDate = checkinDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkinDateValue) : null;
  var toDate = checkoutDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkoutDateValue) : null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
      css: inputBlockStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__/* .CheckinInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate,
        onClick: onClickCheckinDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckInRef
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__/* .CheckoutInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate,
        onClick: onClickCheckoutDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckOutRef
      })]
    }), (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .isPhone */ .Mn)(breakpoint) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__/* .FullScreenModalDialog */ .H, {
      displayed: displayedPicker,
      closeHandler: hidePicker,
      colorMode: "light",
      disableStopBodyScrolling: disableStopBodyScrolling,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__/* .ScrollableDatePicker */ .d, {
        fromDate: fromDate,
        toDate: toDate,
        onComplete: onComplete,
        numberOfMonths: 12,
        maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._r,
        outOfRangeMessage: t("search.calendarMaxDaysMessage"),
        startDateLabel: t("label:common.checkinDate"),
        endDateLabel: t("label:common.checkoutDate"),
        dateType: pickerDateType
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__/* .HorizontalDatePicker */ .R, {
      fromDate: fromDate,
      toDate: toDate,
      onUpdate: onUpdate,
      hidePicker: hidePicker,
      numberOfMonths: 12,
      maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._r,
      outOfRangeMessage: t("search.calendarMaxDaysMessage"),
      startDateLabel: t("label:common.checkinDate"),
      endDateLabel: t("label:common.checkoutDate"),
      displayedPicker: displayedPicker,
      dateType: pickerDateType,
      fromInputRef: inputCheckInRef.current,
      toInputRef: inputCheckOutRef.current
    })]
  });
};

var areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default()(prevProps, nextProps);
};

var HotelDatePickerBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(HotelDatePickerBlockComponent, areEqual);
var blockStyle =  true ? {
  name: "3ldklc",
  styles: "position:relative;flex:1"
} : 0;
var inputBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_20__.css)("display:flex;padding:", _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__/* .space.atom */ .D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 83981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ HotelDestinationBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26793);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_InputAutosuggestBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1399);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79169);
/* harmony import */ var main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86058);
/* harmony import */ var _form_InputHidden__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81047);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14416);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88433);
/* harmony import */ var _suggestionPicker_SuggestionPicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50193);
/* harmony import */ var _molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19484);
/* harmony import */ var _suggestionPicker_SuggestionFieldButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83827);
/* harmony import */ var _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36716);
/* harmony import */ var _constants_FormConstants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36581);
/* harmony import */ var _utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49224);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12327);
/* harmony import */ var _slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35944);























var HotelDestinationBlock = function HotelDestinationBlock(props) {
  var fetchHotelDestinationSuggestions = props.fetchHotelDestinationSuggestions,
      defaultDestinations = props.defaultDestinations,
      suggestOptions = props.suggestOptions,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var appDispatch = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
  var accountDefaultDestinations = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_15__/* .defaultDestinationsSelector */ .fg);
  var destinations = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .hotelDestinationSuggestionsSelector */ .s0);
  var isLoading = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .loadingSelector */ .E2);
  var currentInputData = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .hotelDestinationInputDataSelector */ .TW);
  var currentInputText = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.text;
  var currentInputLongName = currentInputData === null || currentInputData === void 0 ? void 0 : currentInputData.longName; // TODO: 旧reducerをそのまま使用

  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors,
      trigger = _useFormContext.trigger;

  var fieldName = "destination";
  var idFieldName = "destination_id";
  var typeFieldName = "destination_type";
  var longitudeFieldName = "longitude";
  var latitudeFieldName = "latitude";
  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  }) || "";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var inputTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var valueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  valueRef.current = value;
  var currentInputLongNameRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(currentInputLongName);
  currentInputLongNameRef.current = currentInputLongName;
  var currentValue = (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__/* .isPhone */ .Mn)(breakpoint) ? value : value;

  var validDefaultDestinations = function validDefaultDestinations() {
    var _values$find;

    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return (_values$find = values.find(function (value) {
      return value !== undefined && value.length > 0;
    })) !== null && _values$find !== void 0 ? _values$find : [];
  };

  var suggestions = currentValue ? destinations : validDefaultDestinations(defaultDestinations, accountDefaultDestinations);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      clearTimeout(inputTimeoutRef.current);
    };
  }, []);

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
  };

  var onPickerButtonClick = function onPickerButtonClick() {
    setDisplayedPicker(true);
  };

  var onSelected = function onSelected(suggestion) {
    clearTimeout(inputTimeoutRef.current);
    var inputText = currentValue;
    setValue(fieldName, suggestion.longName);
    setValue(idFieldName, suggestion.id);
    setValue(typeFieldName, suggestion.destinationType);
    setValue(longitudeFieldName, suggestion.centerCoordinates[0]);
    setValue(latitudeFieldName, suggestion.centerCoordinates[1]);
    appDispatch((0,main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .setHotelDestinationInputData */ .Hx)({
      text: inputText,
      longName: suggestion.longName
    }));
    void trigger([fieldName, idFieldName]);
    (0,_utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_13__/* .event */ .B)(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_14__/* .GoogleTagManagerEventTypes.origin */ .T.origin, {
      destination_id: suggestion.id,
      destination_type: suggestion.destinationType,
      destination: suggestion.longName
    });

    if (displayedPicker) {
      hidePicker();
    }
  };

  var onClearInput = function onClearInput() {
    clearTimeout(inputTimeoutRef.current);
    setValue(idFieldName, null);
    setValue(fieldName, "");
    setValue(typeFieldName, "");
    setValue(longitudeFieldName, null);
    setValue(latitudeFieldName, null);
    appDispatch((0,main_javascripts_features_hotel_hotelSuggestionSlice__WEBPACK_IMPORTED_MODULE_4__/* .setHotelDestinationInputData */ .Hx)({
      text: "",
      longName: ""
    }));
  }; // reactではinputのvalueが外から変更されてもonChangeが呼ばれないため
  // 変更後のvalueをreact-autosuggestが使用できない
  // そのためreact-autosuggestのfocus時のrequestを
  // disableOnFocusRequestで抑止し、独自でリクエストする


  var onFocus = function onFocus() {
    clearTimeout(inputTimeoutRef.current);
    setValue(fieldName, currentInputText);

    if (currentInputText) {
      fetchHotelDestinationSuggestions({
        text: currentInputText
      });
    }
  };

  var onBlur = function onBlur() {
    // onSelectedより先に呼ばれるため遅延させる
    inputTimeoutRef.current = setTimeout(function () {
      if ( // valueRef.current &&
      currentInputLongNameRef.current && valueRef.current !== currentInputLongNameRef.current) {
        setValue(fieldName, currentInputLongNameRef.current);
        void trigger(fieldName);
      }
    }, 400);
  };

  var error = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .get */ .U2)(errors, fieldName) || (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .get */ .U2)(errors, idFieldName);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: idFieldName
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: typeFieldName
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_form_InputHidden__WEBPACK_IMPORTED_MODULE_5__/* .InputHidden */ .R, {
      name: "center_coordinates[]"
    }), (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_7__/* .isPhone */ .Mn)(breakpoint) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_suggestionPicker_SuggestionFieldButton__WEBPACK_IMPORTED_MODULE_10__/* .SuggestionFieldButton */ .M, {
        namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_12__/* .FormNamespaces.hotel */ .Z.hotel,
        name: fieldName,
        label: {
          namespace: "hotel",
          label: "都市・地域名、ホテル名から検索",
          colorStyleKey: labelColorStyleKey
        },
        longName: value,
        placeholder: t("form.placeholders.hotel.destinationPlaceholder"),
        onClick: onPickerButtonClick,
        borderColorStyleKey: borderColorStyleKey,
        error: error
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_9__/* .FullScreenModalDialog */ .H, {
        displayed: displayedPicker,
        closeHandler: hidePicker,
        colorMode: "light",
        disableStopBodyScrolling: disableStopBodyScrolling,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("div", {
          css: headerTitleStyle,
          children: t("hotel.destination")
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_suggestionPicker_SuggestionPicker__WEBPACK_IMPORTED_MODULE_8__/* .SuggestionPicker */ .W, {
          name: fieldName,
          suggestions: suggestions,
          placeholder: t("form.placeholders.hotel.destinationPlaceholder"),
          isLoading: isLoading,
          suggestOptions: suggestOptions,
          onRequest: fetchHotelDestinationSuggestions,
          onSelected: onSelected,
          onFocus: onFocus,
          onBlur: onBlur,
          onClear: onClearInput
        })]
      })]
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_form_InputAutosuggestBlock__WEBPACK_IMPORTED_MODULE_1__/* .InputAutosuggestBlock */ .A, {
      namespace: "hotel",
      label: {
        namespace: "hotel",
        label: "都市・地域名、ホテル名から検索",
        colorStyleKey: labelColorStyleKey
      },
      input: {
        name: fieldName,
        value: value,
        type: "text",
        placeholder: "目的地またはホテル名を入力"
      },
      error: error,
      onSelected: onSelected,
      onFocus: onFocus,
      onBlur: onBlur,
      fetchDestinationSuggest: fetchHotelDestinationSuggestions,
      suggestOptions: suggestOptions,
      suggestions: suggestions,
      onClear: onClearInput,
      disableOnFocusRequest: true,
      alwaysShowSuggestions: true,
      borderColorStyleKey: borderColorStyleKey
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, " 0 0;flex:1;" + ( true ? "" : 0),  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__.css)("position:absolute;top:0;left:50%;line-height:3rem;font-size:", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";font-weight:bold;letter-spacing:", _styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_11__/* .letterSpacing.text */ .rX.text, ";transform:translateX(-50%);" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 27114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckinInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckinInput = function CheckinInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkin_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックイン",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ }),

/***/ 82011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckoutInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckoutInput = function CheckoutInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkout_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックアウト",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ }),

/***/ 66425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ RecommendedInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(91768);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Search/RecommendedInfo/RecommendedInfoStyle.ts




var RecommendedInfoStyle = es/* StyleSheet.create */.mM.create({
  block: {
    paddingTop: "3rem",
    paddingBottom: "3rem"
  },
  inner: {
    padding: spaceStyle/* space.atom */.D.atom,
    boxSizing: "border-box"
  },
  title: {
    fontSize: typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading,
    lineHeight: typographyStyle/* lineHeight.mediumHeadline2 */.Nv.mediumHeadline2,
    letterSpacing: "0.05em",
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor
  },
  link: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    textDecoration: "none",
    color: colorStyle/* accentColor.primaryColor */.z.primaryColor,
    fontSize: typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading,
    lineHeight: typographyStyle/* lineHeight.mediumHeadline2 */.Nv.mediumHeadline2,
    letterSpacing: "0.05em",
    transition: "color 0.4s ease",
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " 0"),
    maxWidth: "15rem",
    margin: "0 0 0 auto",
    ":hover": {
      color: colorStyle/* accentColor.primaryDarkColor */.z.primaryDarkColor
    }
  },
  linkListBlock: {
    padding: "".concat(spaceStyle/* space.atom2x */.D.atom2x, " 0")
  },
  linkList: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    textDecoration: "none",
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption2 */.Nv.caption2,
    letterSpacing: "0.05em",
    transition: "color 0.4s ease",
    maxWidth: "15rem",
    margin: "0 0 0 auto",
    ":hover": {
      color: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }
});
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Block/BasicBlock/index.ts
var BasicBlock = __webpack_require__(98034);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Link/SimpleTextLinkList/SimpleTextLinkListStyle.ts






var SimpleTextLinkListStyle = es/* StyleSheet.create */.mM.create({
  block: (0,defineProperty/* default */.Z)({
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " 0")
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    display: "flex"
  }),
  label: (0,defineProperty/* default */.Z)({
    fontSize: typographyStyle/* fontSize.body */.JB.body,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    paddingBottom: spaceStyle/* space.atom */.D.atom
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    width: "10rem"
  }),
  listBlock: {
    flex: 1,
    padding: 0
  },
  list: {
    display: "inline-block",
    fontSize: typographyStyle/* fontSize.body */.JB.body,
    lineHeight: typographyStyle/* lineHeight.body1 */.Nv.body1,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    marginBottom: spaceStyle/* space.atom0_5x */.D.atom0_5x,
    ":after": {
      content: '"/"',
      color: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor,
      padding: "0 ".concat(spaceStyle/* space.atom1_5x */.D.atom1_5x),
      opacity: 0.5
    }
  },
  link: {
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    transition: "color 0.4s ease",
    ":hover": {
      color: colorStyle/* accentColor.primaryColor */.z.primaryColor
    }
  }
});
// EXTERNAL MODULE: ./main/javascripts/components/atoms/A/index.ts
var A = __webpack_require__(99931);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Link/SimpleTextLinkList/SimpleTextLinkList.tsx






var SimpleTextLinkList = function SimpleTextLinkList(props) {
  var label = props.label,
      data = props.data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (0,es/* css */.iv)(SimpleTextLinkListStyle.block),
    children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (0,es/* css */.iv)(SimpleTextLinkListStyle.label),
      children: label
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
      className: (0,es/* css */.iv)(SimpleTextLinkListStyle.listBlock),
      children: data.map(function (link, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          className: (0,es/* css */.iv)(SimpleTextLinkListStyle.list),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
            href: link.url,
            styles: SimpleTextLinkListStyle.link,
            children: link.text
          })
        }, index);
      })
    })]
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Link/SimpleTextLinkList/index.ts

// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Search/RecommendedInfo/RecommendedInfo.tsx










var cityCodeData = ["PAR", "LON", "ROM", "BCN", "SFO", "TPE", "SEL", "SIN", "HKG", "DPS", "BKK"];
var RecommendedInfoComponent = function RecommendedInfoComponent(props) {
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      t = props.t;
  var block = styles.block;
  var flightData = cityCodeData.map(function (code) {
    return {
      text: t("constant:cityCode.".concat(code)),
      url: "".concat(Constants/* PATH_SCOPE */.j1, "/lp/flights/dst_regions/").concat(code)
    };
  });
  var hotelData = cityCodeData.map(function (code) {
    return {
      text: t("constant:cityCode.".concat(code)),
      url: "".concat(Constants/* PATH_SCOPE */.j1, "/lp/hotels/dst_regions/").concat(code)
    };
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
    styles: [RecommendedInfoStyle.block, block],
    styleKey: "blockWide",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (0,es/* css */.iv)(RecommendedInfoStyle.inner),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
        className: (0,es/* css */.iv)(RecommendedInfoStyle.title),
        children: t("search.popularDestinations")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,es/* css */.iv)(RecommendedInfoStyle.linkListBlock),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleTextLinkList, {
          label: t("search.flight"),
          data: flightData
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,es/* css */.iv)(RecommendedInfoStyle.linkListBlock),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleTextLinkList, {
          label: t("search.hotel"),
          data: hotelData
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
        className: (0,es/* css */.iv)(RecommendedInfoStyle.link),
        href: "".concat(Constants/* PATH_SCOPE */.j1, "/posts"),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: "\u8A18\u4E8B\u4E00\u89A7"
        }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
          styleKey: "arrowThinR"
        })]
      })]
    })
  });
};
var RecommendedInfo = (0,withTranslation/* withTranslation */.Z)(["component"])(RecommendedInfoComponent);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Search/RecommendedInfo/index.ts


/***/ }),

/***/ 90266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gq": function() { return /* binding */ postSearchDynamicPackageCache; },
/* harmony export */   "Ui": function() { return /* binding */ postResearchDynamicPackageCache; },
/* harmony export */   "Z0": function() { return /* binding */ convertSearchDynamicPackageFormValuesToParams; }
/* harmony export */ });
/* unused harmony export searchDynamicPackageSlice */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95094);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46208);
/* harmony import */ var main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83119);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25968);
/* harmony import */ var _manager_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11166);
/* harmony import */ var _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45021);
/* harmony import */ var _utils_trackingUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18531);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var key = "searchDynamicPackage";
var initialState = {
  loading: false,
  errors: null
};
/** Async **/

var postSearchDynamicPackageCache = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("".concat(key, "/postSearchDynamicPackageCache"), /*#__PURE__*/function () {
  var _ref2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args, _ref) {
    var rejectWithValue, params, url, utmValues, requestParams, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.prev = 1;
            params = args.params;
            url = "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/api/search_dynamic_package/cache");
            utmValues = (0,_utils_trackingUtil__WEBPACK_IMPORTED_MODULE_7__/* .getUtmValues */ .A)();
            requestParams = _objectSpread(_objectSpread({}, utmValues), params);
            _context.next = 8;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().post(url, (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
              conditions: requestParams
            }));

          case 8:
            result = _context.sent;
            return _context.abrupt("return", {
              data: result.data
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context.t0.response.data)));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var postResearchDynamicPackageCache = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("".concat(key, "/postResearchDynamicPackageCache"), /*#__PURE__*/function () {
  var _ref4 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(args, _ref3) {
    var rejectWithValue, cacheId, url, result;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = _ref3.rejectWithValue;
            _context2.prev = 1;
            cacheId = args.cacheId;
            url = "/api/research_dynamic_package/cache.json";
            _context2.next = 6;
            return (0,main_javascripts_api_AxiosWrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .K)().post(url, (0,humps__WEBPACK_IMPORTED_MODULE_2__.decamelizeKeys)({
              cacheId: cacheId
            }));

          case 6:
            result = _context2.sent;
            console.log(result);
            return _context2.abrupt("return", {
              data: result.data
            });

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", rejectWithValue((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelizeKeys)(_context2.t0.response.data)));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
/** slice **/

var searchDynamicPackageSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
  name: key,
  initialState: initialState,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder // 一旦slice単位で共通化
    .addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isPendingAction */ .zY)(key), function (state) {
      state.loading = true;
      state.errors = null;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isFulfilledAction */ .ux)(key), function (state) {
      state.loading = false;
    }).addMatcher((0,main_javascripts_utils_sliceUtil__WEBPACK_IMPORTED_MODULE_4__/* .isRejectedAction */ ._)(key), function (state, action) {
      state.errors = action.payload;
      state.loading = false;
    });
  }
});
var convertSearchDynamicPackageFormValuesToParams = function convertSearchDynamicPackageFormValuesToParams(data) {
  var _params$guests;

  var params = (0,_manager_javascripts_utils_ObjectUtil__WEBPACK_IMPORTED_MODULE_10__/* .clone */ .d9)(data);

  if (params.flight_type === _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_6__/* .FlightTypes.multiCity */ .z.multiCity) {
    delete params.departure_date;
    delete params.return_date;
  } else if (params.flight_type === _constants_FlightTypes__WEBPACK_IMPORTED_MODULE_6__/* .FlightTypes.oneWay */ .z.oneWay) {
    delete params.return_date;
    delete params.itineraries;
  } else {
    delete params.itineraries;
  }

  if (((_params$guests = params.guests) === null || _params$guests === void 0 ? void 0 : _params$guests.length) > 0) {
    params.guests.map(function (guest, index) {
      if (Number(guest.number_of_children) > 0) {
        params.guests[index].ages_of_children = guest.ages_of_children.map(function (age) {
          return age.age;
        });
      } else {
        delete params.guests[index].ages_of_children;
      }
    });
  }

  return params;
};

/***/ }),

/***/ 8832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CategoryTab; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80264);
/* harmony import */ var main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74303);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79169);
/* harmony import */ var _searchPageSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54231);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79105);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36716);
/* harmony import */ var _components_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51752);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var CategoryTab = function CategoryTab() {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t;

  var appDispatch = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
  var searchCategory = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .CG)(_searchPageSlice__WEBPACK_IMPORTED_MODULE_4__/* .searchCategorySelector */ .el);
  var hideCategories = [];

  var onClickHotel = function onClickHotel() {
    appDispatch((0,_searchPageSlice__WEBPACK_IMPORTED_MODULE_4__/* .changeSearchCategory */ .xc)(main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.hotel */ .M.hotel));
  };

  var onClickFlight = function onClickFlight() {
    appDispatch((0,_searchPageSlice__WEBPACK_IMPORTED_MODULE_4__/* .changeSearchCategory */ .xc)(main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.flight */ .M.flight));
  };

  var onClickDynamicPackage = function onClickDynamicPackage() {
    appDispatch((0,_searchPageSlice__WEBPACK_IMPORTED_MODULE_4__/* .changeSearchCategory */ .xc)(main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.dynamicPackage */ .M.dynamicPackage));
  };

  var onClickCruise = function onClickCruise() {
    appDispatch((0,_searchPageSlice__WEBPACK_IMPORTED_MODULE_4__/* .changeSearchCategory */ .xc)(main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.cruise */ .M.cruise));
  };

  var isDisplayCategory = function isDisplayCategory(category) {
    return !(hideCategories && hideCategories.includes(category));
  };

  var hotel = main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.hotel */ .M.hotel,
      flight = main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.flight */ .M.flight,
      dynamicPackage = main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.dynamicPackage */ .M.dynamicPackage,
      cruise = main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_1__/* .searchCategories.cruise */ .M.cruise;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
    css: blockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
      css: innerStyle,
      children: [isDisplayCategory(hotel) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
        css: tabContainerStyle,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
          onClick: onClickHotel,
          css: [tabStyle, searchCategory === hotel ? tabSelectedStyle : null,  true ? "" : 0,  true ? "" : 0],
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
            css: iconStyle,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
              styleKey: "hotel"
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("span", {
            css: labelStyle,
            children: t("search.hotel")
          })]
        })
      }), isDisplayCategory(flight) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
        css: tabContainerStyle,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
          onClick: onClickFlight,
          css: [tabStyle, searchCategory === flight ? tabSelectedStyle : null,  true ? "" : 0,  true ? "" : 0],
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
            css: iconStyle,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
              styleKey: "airplane"
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("span", {
            css: labelStyle,
            children: t("search.flight")
          })]
        })
      }), isDisplayCategory(dynamicPackage) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
        css: [tabContainerStyle, tabContainerWideStyle,  true ? "" : 0,  true ? "" : 0],
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
          onClick: onClickDynamicPackage,
          css: [tabStyle, searchCategory === dynamicPackage ? tabSelectedStyle : null,  true ? "" : 0,  true ? "" : 0],
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
            css: iconStyle,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
              styleKey: "airplane"
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("span", {
            css: verticalMiddleStyle,
            children: "+"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
            css: [iconStyle, iconMultiStyle,  true ? "" : 0,  true ? "" : 0],
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
              styleKey: "hotel"
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("span", {
            css: labelStyle,
            children: [t("search.flight"), " + ", t("search.hotel")]
          })]
        })
      }), isDisplayCategory(cruise) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
        css: tabContainerStyle,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)("div", {
          onClick: onClickCruise,
          css: [tabStyle, searchCategory === cruise ? tabSelectedStyle : null,  true ? "" : 0,  true ? "" : 0],
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
            css: svgIconStyle,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_components_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_10__/* .SvgIcon */ .l, {
              name: "cruise",
              color: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("span", {
            css: labelStyle,
            children: t("search.cruise")
          })]
        })
      })]
    })
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, " 0 0;max-width:600px;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom3x */ .D.atom3x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, " 0;margin:0 auto;}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("desktop"), "{box-sizing:border-box;max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_7__/* .maxWidth.page1colWide */ .k.page1colWide, ";}" + ( true ? "" : 0),  true ? "" : 0);
var innerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("display:flex;border-bottom:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{margin:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var tabContainerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("box-sizing:border-box;width:23%;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{width:auto;}" + ( true ? "" : 0),  true ? "" : 0);
var tabContainerWideStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("width:31%;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{width:auto;}" + ( true ? "" : 0),  true ? "" : 0);
var tabStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("position:relative;cursor:pointer;padding:0.4rem 0.1rem 0;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.smallest */ .JB.smallest, ";text-align:center;height:48px;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";box-sizing:border-box;transition:color 0.3s ease;&:after{content:\"\";display:block;position:absolute;bottom:-1px;left:0;width:100%;height:3px;background-color:transparent;z-index:1;transition:background-color 0.3s ease;}&:hover{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";&:after{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";}}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{display:flex;align-items:center;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom2x */ .D.atom2x, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.caption */ .JB.caption, ";}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom3x */ .D.atom3x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var tabSelectedStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .accentColor.primaryColor */ .z.primaryColor, ";svg{path,rect{fill:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .accentColor.primaryColor */ .z.primaryColor, ";}}&:after{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .accentColor.primaryColor */ .z.primaryColor, ";}&:hover{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .accentColor.primaryColor */ .z.primaryColor, ";&:after{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_8__/* .accentColor.primaryColor */ .z.primaryColor, ";}}" + ( true ? "" : 0),  true ? "" : 0);
var iconStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("display:inline-block;i{font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.headline */ .JB.headline, ";vertical-align:middle;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{position:relative;top:-1px;}}" + ( true ? "" : 0),  true ? "" : 0);
var iconMultiStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("i{padding-left:0.25rem;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding-left:0.25rem;}}" + ( true ? "" : 0),  true ? "" : 0);
var svgIconStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("display:inline-block;margin-bottom:-5px;svg{path,rect{transition:fill 0.3s ease;}}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{margin-bottom:0;}" + ( true ? "" : 0),  true ? "" : 0);
var labelStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__.css)("vertical-align:middle;padding-top:0.2rem;line-height:1;display:block;font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontWeight.bold */ .Ue.bold, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding-top:0;padding-left:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_5__/* .space.atom */ .D.atom, ";display:inline;line-height:41px;}" + ( true ? "" : 0),  true ? "" : 0);
var verticalMiddleStyle =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;

/***/ }),

/***/ 93163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ Search; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/javascripts/constants/SearchCategories.ts
var SearchCategories = __webpack_require__(80264);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/features/search/searchPageSlice.ts
var searchPageSlice = __webpack_require__(54231);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/searchHotelSlice.ts
var searchHotelSlice = __webpack_require__(9296);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/GuestsBlock.tsx + 3 modules
var GuestsBlock = __webpack_require__(88452);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/HotelDestinationBlock.tsx
var HotelDestinationBlock = __webpack_require__(83981);
// EXTERNAL MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx + 1 modules
var ButtonWithLoader = __webpack_require__(51185);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/HotelDatePickerBlock.tsx
var HotelDatePickerBlock = __webpack_require__(65562);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/hotelSuggestionSlice.ts
var hotelSuggestionSlice = __webpack_require__(86058);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/utils/FormUtil.ts
var FormUtil = __webpack_require__(63591);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/components/form/FormErrorsBlock.tsx + 2 modules
var FormErrorsBlock = __webpack_require__(59557);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/search/components/SearchHotel.tsx



var _excluded = ["text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

























es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var schema = es/* object */.Ry().shape({
  destination: es/* string */.Z_().nullable().required(),
  destination_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).required(),
  checkin_date: es/* string */.Z_().nullable().required(),
  checkout_date: es/* string */.Z_().nullable().required(),
  guests: es/* array */.IX().of(es/* object */.Ry().shape({
    number_of_children: es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: es/* array */.IX().of(es/* object */.Ry().shape({
        age: es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required()
      }))
    })
  }))
});
var defaultValues = {
  destination: "",
  checkin_date: null,
  // undefinedではダメ
  checkout_date: null,
  // undefinedではダメ
  number_of_rooms: 1,
  guests: [{
    number_of_adult: 2,
    number_of_children: 0,
    ages_of_children: []
  }]
};
var SearchHotel = function SearchHotel() {
  var router = (0,next_router.useRouter)();
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: defaultValues
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var submitValues;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              submitValues = (0,searchHotelSlice/* convertSearchHotelFormValuesToParams */.Dh)(values);
              setIsSubmitting(true);
              return _context.abrupt("return", appDispatch((0,searchHotelSlice/* postSearchHotelCache */.Yw)({
                params: submitValues
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var cacheId = result.data.cacheId;
                (0,googleTagManagerUtil/* hotelAvailabilitiesEvent */.yb)(cacheId, submitValues);
                router.push("/hotels?".concat((0,lib.stringify)(submitValues, {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(cacheId));
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);
                (0,FormUtil/* formatAndConvertServerErrorToForm */.dR)(errorResponse, setError);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchHotelDestinationSuggestionsAction = function fetchHotelDestinationSuggestionsAction(data) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

    appDispatch((0,hotelSuggestionSlice/* debouncedFetchHotelDestinationSuggestions */.y$)({
      params: _objectSpread({
        text: text
      }, rest)
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: handleFormSubmit,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: firstBlockStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: destBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDestinationBlock/* HotelDestinationBlock */.h, {
              fetchHotelDestinationSuggestions: fetchHotelDestinationSuggestionsAction,
              suggestOptions: {
                excluded_code: "JP"
              },
              labelColorStyleKey: "default",
              borderColorStyleKey: "secondary"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDatePickerBlock/* HotelDatePickerBlock */.F, {
            borderColorStyleKey: "secondary"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestsBlock/* GuestsBlock */.J, {
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
            namespace: FormConstants/* FormNamespaces.hotel */.Z.hotel,
            errors: errors,
            hideValidationErrors: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: submitBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
            type: "submit",
            disabled: isSubmitting,
            isLoading: isSubmitting,
            children: "\u691C \u7D22"
          })
        })]
      })
    }))
  });
};
var submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";width:50%;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:600px;margin:0 auto;padding:0 ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:0 ", spaceStyle/* space.atom */.D.atom, ";margin:", spaceStyle/* space.atom */.D.atom, " auto ", spaceStyle/* space.atom2x */.D.atom2x, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{box-sizing:border-box;max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";}" + ( true ? "" : 0),  true ? "" : 0);
var firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{display:flex;}" + ( true ? "" : 0),  true ? "" : 0);
var destBlockStyle =  true ? {
  name: "82a6rk",
  styles: "flex:1"
} : 0;
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./main/javascripts/components/flight/FlightTravelerBlock.tsx
var FlightTravelerBlock = __webpack_require__(90652);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/CabinClassBlock.tsx
var CabinClassBlock = __webpack_require__(84077);
// EXTERNAL MODULE: ./main/javascripts/components/flight/FlightOriginDestinationDate.tsx + 12 modules
var FlightOriginDestinationDate = __webpack_require__(46385);
// EXTERNAL MODULE: ./main/javascripts/components/flight/form/FlightTypeBlock.tsx
var FlightTypeBlock = __webpack_require__(28090);
// EXTERNAL MODULE: ./main/javascripts/features/flight/searchFlightSlice.ts + 1 modules
var searchFlightSlice = __webpack_require__(71900);
// EXTERNAL MODULE: ./main/javascripts/features/flight/flightSuggestionSlice.ts
var flightSuggestionSlice = __webpack_require__(59960);
// EXTERNAL MODULE: ./main/javascripts/constants/FlightTypes.ts
var FlightTypes = __webpack_require__(45021);
;// CONCATENATED MODULE: ./main/javascripts/features/search/components/SearchFlight.tsx




var SearchFlight_excluded = ["text"];

function SearchFlight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchFlight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchFlight_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchFlight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function SearchFlight_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





























var SearchFlight_defaultValues = {
  departure_date: null,
  // undefinedではダメ
  return_date: null,
  // undefinedではダメ
  traveler: {
    number_of_adult: 2,
    number_of_children: 0
  },
  access_type: "direct_web",
  flight_type: (0,humps.decamelize)("roundTrip"),
  cabin_class: "Y",
  itineraries: [{
    departure_date: null
  }, {
    departure_date: null
  }]
};
es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var SearchFlight_schema = es/* object */.Ry().shape({
  origin: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  origin_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  destination: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  destination_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  departure_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  return_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.roundTrip */.z.roundTrip;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  itineraries: es/* array */.IX().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: function then(schema) {
      return schema.of(es/* object */.Ry().shape({
        origin: es/* string */.Z_().required(),
        origin_id: es/* number */.Rx().required(),
        destination: es/* string */.Z_().required(),
        destination_id: es/* number */.Rx().required(),
        departure_date: es/* string */.Z_().nullable().required()
      }));
    }
  }),
  traveler: es/* object */.Ry().shape({
    number_of_children: es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: es/* array */.IX().of(es/* object */.Ry().shape({
        age: es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required().test("infantsNumber", "infantsNumber", function (value, context) {
          var _parent2$value, _parent2$value2;

          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          var _context$from = (0,slicedToArray/* default */.Z)(context.from, 2),
              _ = _context$from[0],
              parent2 = _context$from[1];

          var infantsNumber = ((parent2 === null || parent2 === void 0 ? void 0 : (_parent2$value = parent2.value) === null || _parent2$value === void 0 ? void 0 : _parent2$value.ages_of_children) || []).filter(function (age) {
            // 空文字を無視したいためparseIntを使用
            return parseInt(age.age) <= 1;
          }).length;
          var adultsNumber = Number((parent2 === null || parent2 === void 0 ? void 0 : (_parent2$value2 = parent2.value) === null || _parent2$value2 === void 0 ? void 0 : _parent2$value2.number_of_adult) || 1);
          return infantsNumber <= adultsNumber;
        })
      }))
    })
  })
});
var SearchFlight = function SearchFlight() {
  var router = (0,next_router.useRouter)();
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(SearchFlight_schema),
    defaultValues: SearchFlight_defaultValues
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var params;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              params = (0,searchFlightSlice/* convertSearchFlightFormValuesToParams */.uI)(values);
              return _context.abrupt("return", appDispatch((0,searchFlightSlice/* postSearchFlightCache */.re)({
                params: params
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var cacheId = result.data.cacheId;
                (0,googleTagManagerUtil/* flightAvailabilitiesEvent */.t6)(cacheId, params);
                router.push("/flights?".concat((0,lib.stringify)(params, {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(cacheId));
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);
                (0,FormUtil/* formatAndConvertServerErrorToForm */.dR)(errorResponse, setError);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchFlightDestinationSuggestionsAction = function fetchFlightDestinationSuggestionsAction(data, type, index) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, SearchFlight_excluded);

    appDispatch((0,flightSuggestionSlice/* debouncedFetchFlightDestinationSuggestions */.tk)({
      params: SearchFlight_objectSpread({
        text: text
      }, rest),
      type: type,
      index: index
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: SearchFlight_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, SearchFlight_objectSpread(SearchFlight_objectSpread({}, methods), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: handleFormSubmit,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: flightTypeBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightTypeBlock/* FlightTypeBlock */.c, {
            labelStyleKey: "labelDark",
            borderColorStyleKey: "secondary"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginDestinationDate/* FlightOriginDestinationDate */.e, {
          destinationSuggestOptions: {},
          fetchFlightOriginDestinationSuggestions: fetchFlightDestinationSuggestionsAction,
          useDatePicker: true,
          searchType: SearchCategories/* searchCategories.flight */.M.flight,
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: flightClassBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinClassBlock/* CabinClassBlock */.B, {
            labelColorStyleKey: "default",
            borderColorStyleKey: "secondary"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightTravelerBlock/* FlightTravelerBlock */.Z, {
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
            namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
            errors: errors,
            hideValidationErrors: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: SearchFlight_submitBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
            type: "submit",
            disabled: isSubmitting,
            isLoading: isSubmitting,
            children: "\u691C \u7D22"
          })
        })]
      })
    }))
  });
};
var SearchFlight_submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";width:50%;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var SearchFlight_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:600px;margin:0 auto;padding:0 ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:0 ", spaceStyle/* space.atom */.D.atom, ";margin:", spaceStyle/* space.atom */.D.atom, " auto ", spaceStyle/* space.atom2x */.D.atom2x, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{box-sizing:border-box;max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";}" + ( true ? "" : 0),  true ? "" : 0);
var flightTypeBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var flightClassBlockStyle =  true ? {
  name: "11vmki4",
  styles: "width:50%;min-width:200px"
} : 0;
// EXTERNAL MODULE: ./main/javascripts/features/dynamicPackage/searchDynamicPackageSlice.ts
var searchDynamicPackageSlice = __webpack_require__(90266);
;// CONCATENATED MODULE: ./main/javascripts/features/search/components/SearchDynamicPackage.tsx



var SearchDynamicPackage_excluded = ["text"];

function SearchDynamicPackage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchDynamicPackage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchDynamicPackage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchDynamicPackage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function SearchDynamicPackage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



























var SearchDynamicPackage_defaultValues = {
  departure_date: null,
  // undefinedではダメ
  return_date: null,
  // undefinedではダメ
  access_type: "direct_web",
  flight_type: (0,humps.decamelize)("roundTrip"),
  cabin_class: "Y",
  itineraries: [{
    departure_date: null
  }, {
    departure_date: null
  }],
  number_of_rooms: 1,
  guests: [{
    number_of_adult: 2,
    number_of_children: 0,
    ages_of_children: []
  }]
};
es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var SearchDynamicPackage_schema = es/* object */.Ry().shape({
  origin: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  origin_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  destination: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  destination_id: es/* number */.Rx().nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }).when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* number */.Rx().nullable().required()
  }),
  departure_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val !== FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  return_date: es/* string */.Z_().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.roundTrip */.z.roundTrip;
    },
    then: es/* string */.Z_().nullable().required()
  }),
  itineraries: es/* array */.IX().nullable().when("flight_type", {
    is: function is(val) {
      return val === FlightTypes/* FlightTypes.multiCity */.z.multiCity;
    },
    then: function then(schema) {
      return schema.of(es/* object */.Ry().shape({
        origin: es/* string */.Z_().required(),
        origin_id: es/* number */.Rx().required(),
        destination: es/* string */.Z_().required(),
        destination_id: es/* number */.Rx().required(),
        departure_date: es/* string */.Z_().nullable().required()
      }));
    }
  }),
  guests: es/* array */.IX().of(es/* object */.Ry().shape({
    number_of_children: es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: es/* array */.IX().of(es/* object */.Ry().shape({
        age: es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required()
      }))
    })
  }))
});
var SearchDynamicPackage = function SearchDynamicPackage() {
  var router = (0,next_router.useRouter)();
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(SearchDynamicPackage_schema),
    defaultValues: SearchDynamicPackage_defaultValues
  });
  var handleSubmit = methods.handleSubmit,
      setError = methods.setError,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var params;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              params = (0,searchDynamicPackageSlice/* convertSearchDynamicPackageFormValuesToParams */.Z0)(values);
              return _context.abrupt("return", appDispatch((0,searchDynamicPackageSlice/* postSearchDynamicPackageCache */.Gq)({
                params: params
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                (0,googleTagManagerUtil/* dpAvailabilitiesEvent */.Yy)(result.data.dynamicPackageId, params);
                router.push("/flights?".concat((0,lib.stringify)((0,humps.decamelizeKeys)(result.data.conditions), {
                  arrayFormat: "indices"
                }), "\n&cache_id=").concat(result.data.cacheId, "\n&dynamic_package_id=").concat(result.data.dynamicPackageId, "&search_group_id=").concat(result.data.searchGroupId, "&search_type=dp"));
              })["catch"](function (errorResponse) {
                setIsSubmitting(false);
                (0,FormUtil/* formatAndConvertServerErrorToForm */.dR)(errorResponse, setError);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchFlightDestinationSuggestionsAction = function fetchFlightDestinationSuggestionsAction(data, type) {
    var text = data.text,
        rest = (0,objectWithoutProperties/* default */.Z)(data, SearchDynamicPackage_excluded);

    appDispatch((0,flightSuggestionSlice/* debouncedFetchFlightDestinationSuggestions */.tk)({
      params: SearchDynamicPackage_objectSpread({
        text: text
      }, rest),
      type: type
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: SearchDynamicPackage_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, SearchDynamicPackage_objectSpread(SearchDynamicPackage_objectSpread({}, methods), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: handleFormSubmit,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: SearchDynamicPackage_firstBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlightOriginDestinationDate/* FlightOriginDestinationDate */.e, {
            destinationSuggestOptions: {},
            fetchFlightOriginDestinationSuggestions: fetchFlightDestinationSuggestionsAction,
            useDatePicker: true,
            labelColorStyleKey: "default",
            borderColorStyleKey: "secondary"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: SearchDynamicPackage_flightClassBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinClassBlock/* CabinClassBlock */.B, {
            labelColorStyleKey: "default",
            borderColorStyleKey: "secondary"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestsBlock/* GuestsBlock */.J, {
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
            namespace: FormConstants/* FormNamespaces.flight */.Z.flight,
            errors: errors,
            hideValidationErrors: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: SearchDynamicPackage_submitBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
            type: "submit",
            disabled: isSubmitting,
            isLoading: isSubmitting,
            children: "\u691C \u7D22"
          })
        })]
      })
    }))
  });
};
var SearchDynamicPackage_submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";width:50%;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var SearchDynamicPackage_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:600px;margin:0 auto;padding:0 ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:0 ", spaceStyle/* space.atom */.D.atom, ";margin:", spaceStyle/* space.atom */.D.atom, " auto ", spaceStyle/* space.atom2x */.D.atom2x, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{box-sizing:border-box;max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";}" + ( true ? "" : 0),  true ? "" : 0);
var SearchDynamicPackage_firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var SearchDynamicPackage_flightClassBlockStyle =  true ? {
  name: "11vmki4",
  styles: "width:50%;min-width:200px"
} : 0;
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseDestinationBlock.tsx + 1 modules
var CruiseDestinationBlock = __webpack_require__(14608);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseDepartureDatePickerBlock.tsx + 2 modules
var CruiseDepartureDatePickerBlock = __webpack_require__(15953);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseOriginBlock.tsx + 1 modules
var CruiseOriginBlock = __webpack_require__(76308);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/form/StaysBlock.tsx
var StaysBlock = __webpack_require__(94477);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/VesselBrandBlock.tsx + 1 modules
var VesselBrandBlock = __webpack_require__(15400);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/features/search/components/SearchCruiseFilterBlock.tsx
function SearchCruiseFilterBlock_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var SearchCruiseFilterBlock = function SearchCruiseFilterBlock() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["button"]),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      isShowFilter = _useState[0],
      setIsShowFilter = _useState[1];

  var onClick = function onClick() {
    setIsShowFilter(!isShowFilter);
  };

  var toggleText = isShowFilter ? t("common.hideFilter") : t("common.showFilter");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [isShowFilter && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseDepartureDatePickerBlock/* CruiseDepartureDatePickerBlock */.e, {
        borderColorStyleKey: "secondary"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: staysBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaysBlock/* StaysBlock */.I, {
          borderColorStyleKey: "secondary"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: col2BlockStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseOriginBlock/* CruiseOriginBlock */.j, {
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VesselBrandBlock/* VesselBrandBlock */.E, {
          labelColorStyleKey: "default",
          borderColorStyleKey: "secondary"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: buttonBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: buttonStyle,
        onClick: onClick,
        children: toggleText
      })
    })]
  });
};
var buttonBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var buttonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption1 */.Nv.caption1, ";text-decoration:underline;text-underline-offset:0.5rem;padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var staysBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:50%;}" + ( true ? "" : 0),  true ? "" : 0);
var col2BlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;justify-content:space-between;}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/features/cruise/cruiseSlice.ts
var cruiseSlice = __webpack_require__(78305);
// EXTERNAL MODULE: ./main/javascripts/slices/accountParamSlice.ts
var accountParamSlice = __webpack_require__(12297);
;// CONCATENATED MODULE: ./main/javascripts/features/search/components/SearchCruise.tsx



function SearchCruise_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchCruise_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchCruise_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchCruise_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var SearchCruise_schema = es/* object */.Ry().shape({});
var SearchCruise_defaultValues = {};
var SearchCruise = function SearchCruise() {
  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["button"]),
      t = _useTranslation.t;

  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var defaultCruiseDestinationSuggestions = (0,store/* useAppSelector */.CG)(accountParamSlice/* cruiseDefaultDestinationSuggestionsSelector */.mf) || [];
  var defaultDestinations = defaultCruiseDestinationSuggestions.map(function (suggestion) {
    return suggestion.region;
  });

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(SearchCruise_schema),
    defaultValues: SearchCruise_defaultValues
  });
  var handleSubmit = methods.handleSubmit,
      clearErrors = methods.clearErrors,
      errors = methods.formState.errors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var params;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              appDispatch((0,cruiseSlice/* clearCruises */.kr)());
              params = (0,cruiseSlice/* convertSearchCruiseFormValuesToParams */.fZ)(values);
              router.push("/cruises?".concat((0,lib.stringify)(params, {
                arrayFormat: "indices"
              })));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: SearchCruise_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, SearchCruise_objectSpread(SearchCruise_objectSpread({}, methods), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: handleFormSubmit,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: SearchCruise_firstBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: SearchCruise_destBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseDestinationBlock/* CruiseDestinationBlock */.N, {
              defaultDestinations: defaultDestinations,
              labelColorStyleKey: "default",
              borderColorStyleKey: "secondary"
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchCruiseFilterBlock, {}), errors && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormErrorsBlock/* FormErrorsBlock */.R, {
            namespace: FormConstants/* FormNamespaces.cruise */.Z.cruise,
            errors: errors,
            hideValidationErrors: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: SearchCruise_submitBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
            type: "submit",
            disabled: isSubmitting,
            isLoading: isSubmitting,
            children: t("common.search")
          })
        })]
      })
    }))
  });
};
var SearchCruise_submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";width:50%;margin-left:auto;margin-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var SearchCruise_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:600px;margin:0 auto;padding:0 ", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:0 ", spaceStyle/* space.atom */.D.atom, ";margin:", spaceStyle/* space.atom */.D.atom, " auto ", spaceStyle/* space.atom2x */.D.atom2x, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{box-sizing:border-box;max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";}" + ( true ? "" : 0),  true ? "" : 0);
var SearchCruise_firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var SearchCruise_destBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("flex:1;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:50%;}" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/features/search/components/Search.tsx









var Search = function Search() {
  var searchCategory = (0,store/* useAppSelector */.CG)(searchPageSlice/* searchCategorySelector */.el);

  switch (searchCategory) {
    case SearchCategories/* searchCategories.hotel */.M.hotel:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHotel, {});

    case SearchCategories/* searchCategories.flight */.M.flight:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFlight, {});

    case SearchCategories/* searchCategories.dynamicPackage */.M.dynamicPackage:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchDynamicPackage, {});

    case SearchCategories/* searchCategories.cruise */.M.cruise:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchCruise, {});

    default:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHotel, {});
  }
};

/***/ }),

/***/ 32915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ SearchChatEntry; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79105);
/* harmony import */ var main_javascripts_components_chat_ChatEntry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35004);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var SearchChatEntry = function SearchChatEntry() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    css: blockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      css: innerStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(main_javascripts_components_chat_ChatEntry__WEBPACK_IMPORTED_MODULE_4__/* .ChatEntry */ .o, {})
    })
  });
};
var blockStyle =  true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0;
var innerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, ";margin:0 -", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, ";width:calc(100% + 2rem);max-width:", main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__/* .maxWidth.page1colWide */ .k.page1colWide, ";box-sizing:border-box;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("tablet"), "{margin:0 auto;width:100%;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);